import React from "react";
import './Button.scss';

export const Button = (props) => {
  return (
    <button onClick={props.onClick} className={`${props.className} button`} type="button">{props.label}</button>
  );
};